import { render, staticRenderFns } from "./warningProcess-dialog.vue?vue&type=template&id=c2f74024&scoped=true"
import script from "./warningProcess-dialog.vue?vue&type=script&lang=js"
export * from "./warningProcess-dialog.vue?vue&type=script&lang=js"
import style0 from "./warningProcess-dialog.vue?vue&type=style&index=0&id=c2f74024&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f74024",
  null
  
)

export default component.exports